__turbopack_context__.v({
  "root": "ImageModal-module__BJOloa__root",
});
